module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/amex_cid-4b178081cff65f7846b44f6705732290.gif";